import { Formik } from 'formik';
import { Link } from 'react-router-dom';
import InputFormik from '../../components/formik/InputFormik';
import Button from '../../components/ui/Button';
import Footer from '../../components/ui/Footer';
import { useAppContext } from '../../context/AppContext';

const LoginPage = () => {
  const { login, authState } = useAppContext();

  return (
    <div className="p-5 sm:p-20 flex flex-col items-center justify-center">
      <div className="w-full rounded-lg shadow border md:mt-0 sm:max-w-md xl:p-0 bg-gray-800 border-gray-700">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h1 className="text-white">Login</h1>
          <Formik
            initialValues={{ username: '', password: '' }}
            onSubmit={(values) => login(values.username, values.password)}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <div className="space-y-3">
                  {authState.errorMessage && (
                    <p className="text-red-700">
                      <i>{authState.errorMessage}</i>
                    </p>
                  )}
                  <InputFormik name="username" isRequired placeholder="Email" type="email" autoComplete="username" />
                  <InputFormik
                    name="password"
                    isRequired
                    placeholder="Passwort"
                    type="password"
                    autoComplete="current-password"
                  />
                  <Button type="submit" isLoading={authState.isLoading}>
                    Einloggen
                  </Button>
                  <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                    Du hast noch keinen Account?{' '}
                    <Link to="/register" className="font-medium hover:underline text-primary-500">
                      Hier registrieren
                    </Link>
                  </p>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginPage;
